if($('.type-detail .p-detail-inner .flag-razba').length){
    var customRazba = '<div class="customRazbaFeed">'
        customRazba += '<div class="left">'
            customRazba += '<div class="h5">První známka</div>'
            customRazba += '<div class="customRowLabel"><label for="first-first">1. řádek <span>*</span></label><input id="first-first" class="form-control" type="text" maxlength="15" required></div>'
            customRazba += '<div class="customRowLabel"><label for="second-first">2. řádek</label><input id="second-first" class="form-control" type="text" maxlength="15"></div>'
            customRazba += '<div class="customRowLabel"><label for="third-first">3. řádek</label><input id="third-first" class="form-control" type="text" maxlength="15"></div>'
            customRazba += '<div class="customRowLabel"><label for="four-first">4. řádek</label><input id="four-first" class="form-control" type="text" maxlength="15"></div>'
            customRazba += '<div class="customRowLabel"><label for="fift-first">5. řádek</label><input id="fift-first" class="form-control" type="text" maxlength="15"></div>'
        customRazba += '</div>'
        customRazba += '<div class="right">'
            customRazba += '<div class="h5">Druhá známka</div>'
            customRazba += '<div class="customRowLabel"><label for="first-second">1. řádek <span>*</span></label><input id="first-second" class="form-control" type="text" maxlength="15" required></div>'
            customRazba += '<div class="customRowLabel"><label for="second-second">2. řádek</label><input id="second-second" class="form-control" type="text" maxlength="15"></div>'
            customRazba += '<div class="customRowLabel"><label for="third-second">3. řádek</label><input id="third-second" class="form-control" type="text" maxlength="15"></div>'
            customRazba += '<div class="customRowLabel"><label for="four-second">4. řádek</label><input id="four-second" class="form-control" type="text" maxlength="15"></div>'
            customRazba += '<div class="customRowLabel"><label for="fift-second">5. řádek</label><input id="fift-second" class="form-control" type="text" maxlength="15"></div>'
        customRazba += '</div>'
    customRazba += '</div>'
    $('.p-info-wrapper').append('<div class="razba hide"><div class="h3">'+razbaNadpis+'</div><p>'+razbaPopis+'</p>'+customRazba+'</div>')
    if($('.vatiant-list').length){
        $(document).on('click', '.custom-variant-wrap .variant', function(){
            $('.razba').removeClass('hide')
        })
    }
    else{
        $(document).ready(function(){
            $('.razba').removeClass('hide')
        })
    }
    

    $('html').on('click', 'body:not(.disabled-add-to-cart) .add-to-cart-button', function() {
        var inputs = [
            { id: '#first-first', value: $('#first-first').val() },
            { id: '#second-first', value: $('#second-first').val() },
            { id: '#third-first', value: $('#third-first').val() },
            { id: '#four-first', value: $('#four-first').val() },
            { id: '#fift-first', value: $('#fift-first').val() },
            { id: '#first-second', value: $('#first-second').val()},
            { id: '#second-second', value: $('#second-second').val() },
            { id: '#third-second', value: $('#third-second').val() },
            { id: '#four-second', value: $('#four-second').val() },
            { id: '#fift-second', value: $('#fift-second').val() }
        ];
        var allValid = true;
        inputs.forEach(function(input) {
            if (input.id === "first-first" || input.id === "first-second") {
                if (!input.value) {
                    $('#' + input.id).addClass('input-error');
                    allValid = false;
                } else {
                    $('#' + input.id).removeClass('input-error');
                }
            }
        });
        if (!allValid) {
            return;
        }
        if($('.variant-list').length){
            var productCode = $('.product-top > .col-xs-12:not(.col-lg-6) > .p-detail-info>.p-code>span:not(.p-code-label):not(.no-display)').text().trim();
        }
        else{
            productCode = $('.product-top > .col-xs-12:not(.col-lg-6) > .p-detail-info>.p-code span:not(.p-code-label)').text().trim()
        }
        var formData = {
            line1first: $('#first-first').val(),
            line2first: $('#second-first').val(),
            line3first: $('#third-first').val(),
            line4first: $('#four-first').val(),
            line5first: $('#fift-first').val(),
            line1second: $('#first-second').val(),
            line2second: $('#second-second').val(),
            line3second: $('#third-second').val(),
            line4second: $('#four-second').val(),
            line5second: $('#fift-second').val()
        };
        var storedData = JSON.parse(sessionStorage.getItem('productsDataRazba')) || {};
        if (!storedData[productCode]) {
            storedData[productCode] = [];
        }
        storedData[productCode].push(formData);
        sessionStorage.setItem('productsDataRazba', JSON.stringify(storedData));
    });   
}

if($('.id--9').length){
    $(document).ready(function() {
        customRazba()
    })

    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        customRazba();
        var storedData = JSON.parse(sessionStorage.getItem('productsDataRazba')) || {};
        $('.cart-table .removeable').each(function() {
            var removeableSKU = $(this).data('micro-sku');
            var amountInView = parseInt($(this).find('.amount').val());
            var amountInStorage = storedData[removeableSKU] ? storedData[removeableSKU].length : 0;
            if (amountInView < amountInStorage) {
                var excess = amountInStorage - amountInView;
                for (var i = 0; i < excess; i++) {
                    
                    if (storedData[removeableSKU]) {
                        storedData[removeableSKU].pop();
                        $(this).next('.razba-row').find('.razbaRow').last().remove();
                    }
                    if (storedData[removeableSKU] && storedData[removeableSKU].length === 0) {
                        delete storedData[removeableSKU];
                    }
                }
                sessionStorage.setItem('productsDataRazba', JSON.stringify(storedData));
            }
        });
    });
    function customRazba(){
        var storedData = JSON.parse(sessionStorage.getItem('productsDataRazba')) || {};
        $('.cart-table .removeable').each(function() {
            var productSKU = $(this).data('micro-sku');
            if (storedData[productSKU]) {
                $(this).addClass('customRazba')
                var labelsHTML = '<tr class="razba-row"><td colspan="6"><ul>';
                storedData[productSKU].forEach(function(item, index) {
                    labelsHTML += '<li class="razbaRow"><strong>Ražba ' + (index + 1) + ':</strong>';
                    labelsHTML += '<ul>';
                    labelsHTML += '<li><strong>První známka:</strong></li>';
                    labelsHTML += '<li><span>1. řádek:</span> ' + item.line1first + '</li>';
                    labelsHTML += '<li><span>2. řádek:</span> ' + item.line1second + '</li>';
                    labelsHTML += '<li><span>3. řádek:</span> ' + item.line3first + '</li>';
                    labelsHTML += '<li><span>4. řádek:</span> ' + item.line4first + '</li>';
                    labelsHTML += '<li><span>5. řádek:</span> ' + item.line5first + '</li>';
                    labelsHTML += '</ul>';
                    labelsHTML += '<ul>';
                    labelsHTML += '<li><strong>Druhá známka:</strong></li>';
                    labelsHTML += '<li><span>1. řádek:</span> ' + item.line1second + '</li>';
                    labelsHTML += '<li><span>2. řádek:</span> ' + item.line2second + '</li>';
                    labelsHTML += '<li><span>3. řádek:</span> ' + item.line3second + '</li>';
                    labelsHTML += '<li><span>4. řádek:</span> ' + item.line4second + '</li>';
                    labelsHTML += '<li><span>5. řádek:</span> ' + item.line5second + '</li>';
                    labelsHTML += '</ul>';
                    labelsHTML += '<button class="remove-razba" data-sku="' + productSKU + '" data-index="' + index + '">Smazat ražbu</button>';
                    labelsHTML += '</li>';
                });
                labelsHTML += '</ul></td></tr>';
                $(this).after(labelsHTML);
            }
        });
    }
}

if($('.id--17').length){
    shoptet.scripts.setCustomFunction("postSuccessfulValidation",function(form, args) {
            if ($(form).attr("id") === "order-form") {
                UlozitPoznamku();
            }
            return true;
        }
    );
}

if($('.id--15').length){
    setTimeout(function() {
        sessionStorage.removeItem("productsDataRazba");
    }, 2000);
}

function UlozitPoznamku() {
    var NotesArrayStr = sessionStorage.getItem("productsDataRazba");
    var noteText = "";
    if (NotesArrayStr !== null) {
        var NotesArray = JSON.parse(NotesArrayStr);
        $(getShoptetDataLayer('cart')).each(function() {
            const num = this.code;
            if (NotesArray[num]) {
                var product = NotesArray[num];
                product.forEach(function(razba) {
                    noteText += "Produkt: " + num + ";\n";
                    noteText += "Ražba známek:\n";
                    noteText += "První známka:\n";
                    noteText += "1. řádek: " + razba.line1first + "\n";
                    noteText += "2. řádek: " + razba.line2first + "\n";
                    noteText += "3. řádek: " + razba.line3first + "\n";
                    noteText += "4. řádek: " + razba.line4first + "\n";
                    noteText += "5. řádek: " + razba.line5first + "\n";
                    noteText += "Druhá známka:\n";
                    noteText += "1. řádek: " + razba.line1second + "\n";
                    noteText += "2. řádek: " + razba.line2second + "\n";
                    noteText += "3. řádek: " + razba.line3second + "\n";
                    noteText += "4. řádek: " + razba.line4second + "\n";
                    noteText += "5. řádek: " + razba.line5second + "\n";
                    noteText += "\n";
                });
            }
        });
        var actText = 'Váš komentář k objednávce: ' + $("#remark").val()+'\n';
        if (actText.length > 0) {
            actText += "\n";
        } else {
            actText = $("#remark").val();
            if (actText.length > 0) {
                actText += "\n";
            }
        }
        $("#remark").text(actText + noteText);
        $("#remark").val(actText + noteText);
   
    }
}


$('body').on('click', '.remove-razba', function() {
    var productSKU = $(this).data('sku');
    var indexToRemove = $(this).data('index');
    var storedData = JSON.parse(sessionStorage.getItem('productsDataRazba')) || {};
    if (storedData[productSKU]) {
        storedData[productSKU].splice(indexToRemove, 1);
        if (storedData[productSKU].length === 0) {
            delete storedData[productSKU];
        }
        sessionStorage.setItem('productsDataRazba', JSON.stringify(storedData));
        $(this).closest('.razbaRow').remove();
    }
});